import environment from "@/config/enviroment"

export const isDevEnv = environment.env === "development"
